module.exports = __webpack_public_path__ + "img/error.20c08298.png";